import { AppPage, AppPages } from './app-page';
import { AppVersionInfo } from '../helpers/app-environment';

export class CachedAppState {
  static StoreKey: string = 'AppState';
  activePage: AppPage = AppPages.login;
  versionInfo: AppVersionInfo = { branch: '', dateTime: 0, revision: '', version: '' };
  sessionCreated = Date.now();
}
